module.exports = __webpack_public_path__ + "static/media/new-logo-cmtech.57af5263.png";